export enum TipoFile {
    IMAGEM = 1,
    VIDEO = 2,
    DOCUMENTO = 3,
    GIF = 4
}
